export default __webpack_public_path__ + "static/media/meekicks-trailer.fc409340.mp4";